import RestrictedBodyText from './RestrictedBodyText';
export default RestrictedBodyText;
